import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import CtaButton from "@/components/CtaButton";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page Not Found | Web Pilot"
        description="The page you're looking for doesn't exist. Head back to the Web Pilot home page."
      />
      <section className="bg-navy py-24 text-center sm:py-32">
        <div className="mx-auto max-w-xl px-4">
          <p className="font-display text-7xl font-extrabold text-skyblue">404</p>
          <h1 className="mt-4 font-display text-2xl font-bold text-white sm:text-3xl">
            Page not found.
          </h1>
          <p className="mt-3 text-slate-300">
            The page you're looking for doesn't exist or has moved.
          </p>
          <div className="mt-9 flex flex-col justify-center gap-4 sm:flex-row">
            <CtaButton to="/" testId="notfound-home-button">
              Back to home
            </CtaButton>
            <Link
              to="/contact"
              data-testid="notfound-contact-link"
              className="inline-flex min-h-12 items-center justify-center rounded-lg border border-white/20 px-6 py-3 font-display font-bold text-white transition-colors hover:bg-white/10"
            >
              Get a Free Preview
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
